import { Routes } from '@angular/router';
import { dashboardRoutes } from '@adm-web-app/modules/dashboard/dashboard.routing';
import { compositeProductsRoutes } from '@adm-web-app/modules/composite-products/composite-products.routing';
import { productDefinitionsRoutes } from '@adm-web-app/modules/product-definitions/product-definitions.routing';
import { productCategoriesRoutes } from '@adm-web-app/modules/product-categories/product-categories.routing';
import { permissionsRoutes } from '@adm-web-app/modules/permissions/permissions.routing';
import { promoBannersRoutes } from '@adm-web-app/modules/promo-banners/promo-banners.routing';
import { orgRoutes } from '@adm-web-app/modules/organizations/organizations.routing';
import { storesRoutes } from '@adm-web-app/modules/stores/stores.routing';
import { webkassCashboxesRoutes } from '@adm-web-app/modules/webkassa-cashboxes/webkassa-cashboxes.routing';
import { citiesRoutes } from '@adm-web-app/modules/cities/cities.routing';
import { brandsRoutes } from '@adm-web-app/modules/brands/brandsRoutes';
import { deliveryZonesRoutes } from '@adm-web-app/modules/delivery-zones/delivery-zones.routing';
import { workflowsRoutes } from '@adm-web-app/modules/workflows/workflows.routing';
import { operationsRoutes } from '@adm-web-app/modules/operations/operations.routing';
import { faqRoutes } from '@adm-web-app/modules/faqs/faq.routing';
import { dictionariesRoutes } from '@adm-web-app/modules/dictionaries/dictionary.routing';
import { appVersionsRoutes } from '@adm-web-app/modules/app-versions/app-versions.routing';

export const appRoutes: Routes = [
  {
    path: '', pathMatch: 'full', redirectTo: '/dashboard'
  },
  {
    path: 'dashboard',
    children: dashboardRoutes,
  },
  {
    path: 'composite-products',
    children: compositeProductsRoutes,
    data: {
      breadcrumb: 'CompositeProducts'
    }
  },
  {
    path: 'product-definitions',
    children: productDefinitionsRoutes,
    data: {
      breadcrumb: 'ProductDefinitions'
    }
  },
  {
    path: 'product-categories',
    children: productCategoriesRoutes,
    data: {
      breadcrumb: 'ProductCategories'
    }
  },
  {
    path: 'permissions',
    children: permissionsRoutes,
    data: {
      breadcrumb: 'Permissions'
    }
  },
  {
    path: 'promo-banners',
    children: promoBannersRoutes,
    data: {
      breadcrumb: 'PromoBanners'
    }
  },
  {
    path: 'organizations',
    children: orgRoutes,
    data: {
      breadcrumb: 'Organizations'
    }
  },
  {
    path: 'stores',
    children: storesRoutes,
    data: {
      breadcrumb: 'Stores'
    }
  },
  {
    path: 'webkassa-cashboxes',
    children: webkassCashboxesRoutes,
    data: {
      breadcrumb: 'WebkassaCashboxes'
    }
  },
  {
    path: 'cities',
    children: citiesRoutes,
    data: {
      breadcrumb: 'Cities'
    }
  },
  {
    path: 'brands',
    children: brandsRoutes,
    data: {
      breadcrumb: 'Brands'
    }
  },
  {
    path: 'delivery-zones',
    children: deliveryZonesRoutes,
    data: {
      breadcrumb: 'DeliveryZones'
    }
  },
  {
    path: 'workflows',
    children: workflowsRoutes,
    data: {
      breadcrumb: 'Workflows'
    }
  },
  {
    path: 'operations',
    children: operationsRoutes,
    data: {
      breadcrumb: 'Operations'
    }
  },
  {
    path: 'faqs',
    children: faqRoutes,
    data: {
      breadcrumb: 'Faqs'
    }
  },
  {
    path: 'dictionaries',
    children: dictionariesRoutes,
    data: {
      breadcrumb: 'Dictionaries'
    }
  },
  {
    path: 'app-versions',
    children: appVersionsRoutes,
    data: {
      breadcrumb: 'AppVersions'
    }
  },
];
